// Ordered list of supported pino log levels
var pinoLogLevels = [
    'fatal',
    'error',
    'warn',
    'info',
    'debug',
    'trace',
];
export var getLogLevelIndex = function (logLevel, logLevels) {
    if (logLevels === void 0) { logLevels = pinoLogLevels; }
    var logLevelIndex = logLevels.findIndex(function (level) { return level === logLevel; });
    return logLevelIndex === -1 ? undefined : logLevelIndex;
};
/**
 * Retrieve a string log level descriptor via an array index.
 *
 * @param logLevelIndex the array index of the log level string.
 * @param logLevels the array of log level strings.
 * @returns the log level string descriptor, if found, and undefined otherwise.
 */
export var getPinoLogLevelByIndex = function (logLevelIndex, logLevels) {
    if (logLevels === void 0) { logLevels = pinoLogLevels; }
    return logLevels[logLevelIndex];
};
export var getLogLevel = function (logLevel) {
    var levelIndex = getLogLevelIndex(logLevel);
    if (levelIndex !== undefined) {
        // This will fail safely with undefined if log level cannot be determined
        return getPinoLogLevelByIndex(levelIndex);
    }
    // Do not assume a log level in other circumstances
    return undefined;
};
